/** @jsxImportSource @emotion/react */
import { Global, css } from "@emotion/react";

export const GlobalStyles = () => (
  <Global
    styles={css`
      * {
        box-sizing: border-box;
      }

      html,
      body {
        margin: 0;
        padding: 0;
        // background: #0f0f10;
        color: #ffffff;
        font-family: "Playfair Display", Georgia, "Times New Roman", serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      a {
        color: inherit;
        text-decoration: none;
      }

      /* 🔥 Ant Design override */
      .ant-typography,
      .ant-card,
      .ant-btn,
      .ant-list,
      .ant-tag,
      .ant-spin {
        font-family: "Playfair Display", Georgia, serif;
      }
    `}
  />
);
